import { Overlay } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RtUICoreRtlModule } from '../rtl/rtl.module';
import { RtOverlay } from './cdk-overlay';
import { RtOverlayContainer } from './overlay-container';
import {
  ConnectedOverlayDirective,
  ModifiedCdkConnectedOverlay,
  OverlayOriginDirective,
  OverlayPosition,
} from './overlay-directives';
import { OverlayRef } from './overlay-ref';
import { OverlayState, RtOverlayConfig } from './overlay-state';
import { OverlayService } from './overlay.service';
import { ScrollableDirective } from './scroll/scrollable.directive';

const DIRECTIVES = [OverlayOriginDirective, ScrollableDirective];

@NgModule({
  imports: [CommonModule, PortalModule, RtUICoreRtlModule, ConnectedOverlayDirective],
  declarations: [...DIRECTIVES],
  // We intentionally provide separate OverlayService for each module,
  // so the dialogs are opened in a scope of that module
  providers: [
    {
      provide: Overlay,
      useExisting: RtOverlay,
    },
  ],
  exports: [...DIRECTIVES, ConnectedOverlayDirective],
})
export class RtUICoreOverlayModule {}
export {
  OverlayService,
  ModifiedCdkConnectedOverlay,
  ConnectedOverlayDirective,
  OverlayOriginDirective,
  ScrollableDirective,
  RtOverlayContainer,
  OverlayRef,
  OverlayState,
  RtOverlayConfig,
  ScrollDispatcher,
  OverlayPosition,
};
export {
  ConnectionPositionPair,
  OriginConnectionPosition,
  OverlayConnectionPosition,
} from '@angular/cdk/overlay';
